var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
import React from 'react';
import styled, { css } from 'styled-components';
import { classNames, toArray } from '@shapeable/utils';
import { breakpoints, theme } from '@shapeable/theme';
import { EntityFilterSelect } from './entity-filter-select';
import { entitySelectSlugTransform } from './entity-select';
import { Grid } from '../elements/grid';
import { useLang } from '../hooks/use-lang';
import { sprintf } from 'sprintf-js';
import { EntityTypeTogglePill } from './entity-type-toggle-pill';
import { keyBy, mapValues, includes, without, compact, filter } from 'lodash';
import { useView } from '../hooks/use-view';
var cls = classNames('entity-filters');
export var EntityFiltersDefaultProps = {
  selects: [],
  typeToggles: [],
  onTypeChange: function () {}
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["  \n    display: flex;\n    gap: ", ";\n    flex-direction: column;\n    flex-wrap: wrap;\n  "], ["  \n    display: flex;\n    gap: ", ";\n    flex-direction: column;\n    flex-wrap: wrap;\n  "])), theme.UNIT(2)),
  tablet: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    gap: ", ";\n    flex-direction: row;\n  "], ["\n    gap: ", ";\n    flex-direction: row;\n  "])), theme.UNIT(3)),
  desktop: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var ItemStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    flex-grow: 1;\n    flex-shrink: 0;\n    min-width: 150px;\n    box-sizing: border-box;\n  "], ["\n    flex-grow: 1;\n    flex-shrink: 0;\n    min-width: 150px;\n    box-sizing: border-box;\n  "]))),
  tablet: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var SelectStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    flex-grow: 1;\n  "], ["\n    flex-grow: 1;\n  "])))
});
var SelectsLayoutStyles = breakpoints({
  base: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    flex-grow: 1;\n    .shp--grid__item {\n      display: block;\n    };\n  "], ["\n    flex-grow: 1;\n    .shp--grid__item {\n      display: block;\n    };\n  "]))),
  tablet: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    margin-bottom: -", ";\n  "], ["\n    margin-bottom: -", ";\n  "])), theme.UNIT(2))
});
var TogglesStyles = breakpoints({
  base: css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    display: flex;\n    flex-wrap: wrap;\n    gap: ", ";\n    flex-shrink: 1;\n    \n  "], ["\n    display: flex;\n    flex-wrap: wrap;\n    gap: ", ";\n    flex-shrink: 1;\n    \n  "])), theme.UNIT(3))
});
var DividerStyles = breakpoints({
  base: css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    display: none;\n    height: ", ";\n    margin-top: 2px;\n    flex-shrink: 1;\n    flex-grow: 0;\n    background-position: top left;\n  "], ["\n    display: none;\n    height: ", ";\n    margin-top: 2px;\n    flex-shrink: 1;\n    flex-grow: 0;\n    background-position: top left;\n  "])), theme.UNIT(8)),
  desktopLarge: css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    display: flex;\n  "], ["\n    display: flex;\n  "])))
});
var ToggleStyles = breakpoints({
  base: css(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    flex-shrink: 1;\n  "], ["\n    flex-shrink: 1;\n  "])))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Toggles: styled.div(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), TogglesStyles),
  Toggle: styled(EntityTypeTogglePill)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), ToggleStyles),
  // Divider: styled(DottedLine)`${DividerStyles}`,
  SelectsLayout: styled(Grid)(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", ""], ["", ""])), SelectsLayoutStyles),
  Item: styled.div.attrs(cls.attr('item'))(templateObject_17 || (templateObject_17 = __makeTemplateObject(["", ""], ["", ""])), ItemStyles),
  Select: styled(EntityFilterSelect)(templateObject_18 || (templateObject_18 = __makeTemplateObject(["", ""], ["", ""])), SelectStyles)
};
export var EntityFilters = function (props) {
  var className = props.className,
    selects = props.selects,
    view = props.view,
    typeToggles = props.typeToggles,
    onTypeChange = props.onTypeChange,
    results = props.results;
  var t = useLang();
  var ALL_TEMPLATE = t('(All %s)');
  var selectsDictionary = React.useMemo(function () {
    return mapValues(keyBy(selects, 'name'), function (item) {
      return keyBy(item.items, 'slug');
    });
  }, [selects]);
  var _a = useView(view),
    filters = _a.filters,
    _b = _a.selectedTypes,
    selectedTypes = _b === void 0 ? [] : _b,
    setTypes = _a.setTypes,
    onEntityFilterChange = _a.onEntityFilterChange;
  var allEntityTypeNames = typeToggles.map(function (type) {
    return type.name;
  });
  var hasTypeToggles = !!typeToggles.length;
  var hasSelects = !!selects.length;
  var fieldNamesByName = React.useMemo(function () {
    return mapValues(keyBy(selects, 'name'), function (select) {
      return select.fieldName || select.name;
    });
  }, [selects]);
  var namesByFieldName = React.useMemo(function () {
    return mapValues(keyBy(selects, function (select) {
      return select.fieldName || select.name;
    }), 'name');
  }, [selects]);
  var setEntityTypeNames = function (names) {
    setTypes(
    // we also store the ACTUAL selection, to render the visual state
    names, names.length ? names : allEntityTypeNames);
  };
  var hintedSelects = React.useMemo(function () {
    // look through the current data set (if provided) and filter out any options that aren't present
    if (!results) {
      return selects;
    }
    var newSelects = selects.map(function (select) {
      var newItems = select.items.filter(function (item) {
        return results.find(function (result) {
          var resultFieldSlugs = select.getResultFieldSlugs ? select.getResultFieldSlugs(result, select.name) : filter(toArray(result[fieldNamesByName[select.name]])).map(function (item) {
            return item.slug;
          });
          return includes(resultFieldSlugs, item.slug);
        });
      });
      return __assign(__assign({}, select), {
        items: newItems
      });
    });
    return newSelects;
  }, [results, selects]);
  // when nothing is selected initially, we want the state to reflect them all being selected 
  React.useEffect(function () {
    setEntityTypeNames(selectedTypes);
  }, []);
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, hasTypeToggles && React.createElement(My.Toggles, null, typeToggles.map(function (type) {
    var isOn = includes(selectedTypes, type.name);
    return React.createElement(My.Toggle, {
      key: type.name,
      label: type.label,
      entityTypeName: type.name,
      isOn: isOn,
      onClick: function () {
        var newSelectedTypes = isOn ? without(selectedTypes, type.name) : __spreadArray([type.name], __read(selectedTypes), false);
        onTypeChange(newSelectedTypes);
        setEntityTypeNames(newSelectedTypes);
      }
    });
  })), hasSelects && React.createElement(My.SelectsLayout, {
    spacing: 3,
    maxColumns: selects.length,
    tabletAutoColumns: selects.length,
    items: hintedSelects.map(function (item) {
      var onChange = function (name) {
        return function (items) {
          var handler = item.onChange || onEntityFilterChange;
          if (handler) {
            handler(name, items);
          }
        };
      };
      var value = filters[item.name] || [];
      // values are simple slugs, but we need to convert them to a { value: slug, label: name, entity: Entity } format
      var selectValue = compact(toArray(value).map(function (v) {
        var entity = selectsDictionary[item.name][v];
        if (!entity) {
          return null;
        }
        return entitySelectSlugTransform(selectsDictionary[item.name][v]);
      }));
      var placeholder = sprintf(ALL_TEMPLATE, item.pluralLabel);
      return React.createElement(My.Item, {
        key: item.name
      }, React.createElement(My.Select, {
        value: selectValue,
        transform: entitySelectSlugTransform,
        onChange: onChange(item.name),
        size: "slim",
        placeholder: placeholder,
        isClearable: true,
        isMulti: true,
        items: item.items
      }));
    })
  }));
};
EntityFilters.defaultProps = EntityFiltersDefaultProps;
EntityFilters.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18;